import { Button, Col, DatePicker, Form, Input, Row, Select, Space } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, ArrowLeftOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseSelect } from '@app/components/common/selects/BaseSelect/BaseSelect';
import { BaseInput } from '@app/components/common/inputs/BaseInput/BaseInput';
import { DropdownOption } from '@app/models/DropdownOption';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';

type FollowUpProps = {
  editable: boolean;
  acceptedFields: any;
  productCategories: DropdownOption[];
  //country_options: DropdownOption[];
  // eslint-disable-next-line @typescript-eslint/ban-types
  setAcceptedFields: Function;
  form: any;
  importData: any;
  FollowUpData: any;
  countries?: any[];
};

const FollowUpInfo: React.FC<FollowUpProps> = ({
  editable,
  productCategories,
  acceptedFields = {},
  //country_options,
  setAcceptedFields,
  form,
  importData,
  FollowUpData,
  countries = [],
}) => {
  const [selectedImport, setSelectedImport] = useState<any>(null);
  const levelOptions = [1, 2, 3, 4, 5].map((level) => ({
    value: level,
    label: level.toString(),
  }));

  useEffect(() => {
    const importType = localStorage.getItem('importType');
    if (importType && !form.getFieldValue('type')) {
      form.setFieldsValue({ type: importType });
    }
  }, [form]);

  useEffect(() => {
    if (importData && form.getFieldValue('import_id')) {
      const found = importData.import_dropdown?.find((imp: any) => imp.value === form.getFieldValue('import_id'));
      if (found) {
        populateImportFields(found);
      }
    }
    populateFollowUpFields(FollowUpData);
  }, [form, importData, FollowUpData]);

  const populateImportFields = (selected: any) => {
    setSelectedImport(selected);
    form.setFieldsValue({
      allowed_weightage: selected.allowed_weightage,
      consignment_status: selected.consignment_status,
      //  country_ids: selected.countries.map((c: any) => c.id),
    });
  };
  const populateFollowUpFields = (FollowUpData: any) => {
    console.log('FollowUpData:', FollowUpData);
    setSelectedImport(FollowUpData);
    form.setFieldsValue({
      status: FollowUpData?.status,
      allowed_weightage: FollowUpData?.import?.allowed_weightage,
      consignment_status: FollowUpData?.import?.consignment_status,
      //  country_ids: FollowUpData?.import?.countries?.map((c: any) => c.id),
      import_id: FollowUpData?.import?.id,
      import_date: FollowUpData?.import?.expire_date,
      level: FollowUpData?.level,
    });
  };

  //console.log('FollowUpInfo received FollowUpData:', FollowUpData);

  const fields: any = [
    {
      name: 'allowed_weightage',
      label: 'Allowed Weightage',
      component: <BaseInput readOnly value={form.getFieldValue('allowed_weightage')} />,
    },
    {
      name: 'consignment_status',
      label: 'Consignment Status',
      component: <BaseInput readOnly value={form.getFieldValue('consignment_status')} />,
    },
    {
      name: 'level',
      label: 'Follow Up Level',
      component: <BaseInput readOnly value={form.getFieldValue('level')} />,
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      {/* Import Selection */}
      <BaseCol xs={24} md={12}>
        <Form.Item
          label={<Space>Import</Space>}
          name="import_id"
          rules={[{ required: true, message: 'Please select an import' }]}
        >
          <BaseInput
            readOnly
            value={
              importData?.import_dropdown?.find((i: any) => i.value === form.getFieldValue('import_id'))?.label || '-'
            }
          />
        </Form.Item>
      </BaseCol>

      {/* Countries */}
      <BaseCol xs={24} md={12}>
        <Form.Item label={<Space>Countries</Space>}>
          <BaseInput
            readOnly
            value={countries
              .map((item) => item?.name)
              .filter(Boolean)
              .join(', ')}
          />
        </Form.Item>
      </BaseCol>

      {/* Consignment Type - Always Fixed */}
      <BaseCol xs={24} md={12}>
        <Form.Item
          label={<Space style={{ display: 'flex', alignItems: 'center' }}>Consignment Type</Space>}
          name="consignment_type"
        >
          <Input.Group compact style={{ display: 'flex', width: '100%' }}>
            <BaseInput readOnly value="Import" />
          </Input.Group>
        </Form.Item>
      </BaseCol>

      {/* Static Read-Only Fields */}
      {fields.map((e: any) => (
        <Col xs={24} md={12} key={e.name}>
          <Form.Item name={e.name} label={<Space style={{ display: 'flex', alignItems: 'center' }}>{e.label}</Space>}>
            {e.component}
          </Form.Item>
        </Col>
      ))}
    </Row>
  );
};

export default FollowUpInfo;
